// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/banner-promo-overlay/banner-promo-overlay.component.scss
// module id = 580
// module chunks = 0